import Vue from 'vue'
import Vuex from 'vuex' // https://vuex.vuejs.org/fr/

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    // Développement
    rootApiMaps: "https://maps.cmem-mat.info/api/",
    rootApi: process.env.ROOT_API,
    isProd: process.env.NODE_ENV == "production",
    loader: 0,
    self: {},
    trelloConfig: {
      boardConfig: {},
      userConfig: [],
      typeDemandeConfig: [],
      prioriteConfig: [],
      projetsConfig: [],
      internalBoard: {},
      loaded: false
    }

  },
  mutations: {
    updateSelf(state, newSelf) {
      state.self = { ...state.self, ...newSelf }
    },
    redirectToConnect(state) {
      if (state.isProd) // En prod
        window.location.href = "http://cmem-mat.info";
      else // En dev/preprod
        window.alert("redirect to intranet");
    },
    displayLoader(state, inc) {
      if (inc) state.loader += 1;
      else state.loader -= 1;
    },
    setTrelloConfig(state, newConf) {
      state.trelloConfig = { ...state.trelloConfig, ...newConf };
      state.trelloConfig.loaded = true;
    }
  },
  actions: {
    loadTrelloConfig(context) {
      return new Promise((resolve) => {
        fetch("static/trelloConfig.json")
          .then(res => res.json())
          .then(trelloConfig => {
            context.commit("setTrelloConfig", trelloConfig)
            resolve();
          })
      })
    }
  }
})

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js